import React, { useEffect, useState } from 'react';
import { Mask } from 'antd-mobile';
import Danmaku from './Danmaku';
import { personalityResult } from './const';
import BTN1 from '../../static/media/cxcs.png';
import BTN2 from '../../static/media/yqhycs.png';
import FXT from '../../static/media/ydzf.png';
const Result = ({ danmakuMessages = [], lookFriend }) => {
  // const danmakuMessages = ['Kevin 王剑 测试结果ENTJ 猫猫指挥官', '祝越 Cody 测试结果INTJ 刺猬建筑师', '朱金鑫 Amy 测试结果ISFP 探险小兔', '朱金鑫 Amy 测试结果ISFP 探险小兔', '朱金鑫 Amy 测试结果ISFP 探险小兔']; // 你的弹幕消息数组
  return (
    <div>
      
      {/* 其他 Result 组件的内容 */}
      <Danmaku messages={danmakuMessages} lookFriend={lookFriend} />
    </div>
  );
};

const TestResult = ({ topFourTypes, nickname, userInfo, goBackToQuestions, lookFriend }) => {
  console.log('TestResult Props:', topFourTypes, nickname);
  // Create a mapping between types and image paths
  const typeMap = {
    'ISTJ': 'istj',
    'ISFJ': 'isfj',
    'INFJ': 'infj',
    'INTJ': 'intj',
    'ISTP': 'istp',
    'ISFP': 'isfp',
    'INFP': 'infp',
    'INTP': 'intp',
    'ESTP': 'estp',
    'ESFP': 'esfp',
    'ENFP': 'enfp',
    'ENTP': 'entp',
    'ESTJ': 'estj',
    'ESFJ': 'esfj',
    'ENFJ': 'enfj',
    'ENTJ': 'entj'
  };

  const normalizedType = typeMap[topFourTypes];


  console.log(topFourTypes, typeMap[topFourTypes]);
  console.log(normalizedType);
  const imagePath = `/static/media/${normalizedType}.jpg`;

  const [danmakuMessages, setDanmakuMessages] = useState([]);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if(topFourTypes){
      getLastFiveList();
    }
  }, [topFourTypes]);

  const getLastFiveList = () => {
    fetch(`//home-service.chinanestor.com/openAPI/activity/queryLastFiveList`).then(res => res.json()).then(res => {
      if(res.data){
        const _danmakuMessages = [];
        res.data.map((item) => {
          const { testResult, nickName, headPortrait } = item;
          personalityResult.filter((item2) => {
            if(item2.type === testResult){
              _danmakuMessages.push({
                messages: `${nickName} 测试结果${testResult} ${item2.nickname}`,
                headPortrait,
              })
            }
          })
        });
        setDanmakuMessages(_danmakuMessages);
      }
    }).catch(err => console.log(err))
  }

  const delTestResult = () => {
    fetch(`//home-service.chinanestor.com/openAPI/activity/delTestResult`, {
        method: 'POST',
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          submitter: userInfo.openId,
        })
      }).then(res => res.json()).then(res => {
        goBackToQuestions();
      });
  }

  return (
    <div style={{ position: 'relative' }}>
      <Result danmakuMessages={danmakuMessages} lookFriend={lookFriend} />
      <p style={{color:'white', fontSize:12, paddingTop:10,marginBottom:10}}>测试结果纯属娱乐，请勿用于任何商业用途</p>
      <img src={process.env.PUBLIC_URL + imagePath} alt="" />
      <div style={{ position: 'fixed', bottom: 10, display: 'flex', alignItems: 'center', justifyContent: 'space-around', width: '100%' }}>
        <img style={{ width: '45%' }} src={BTN1} alt="" onClick={delTestResult} />
        <img style={{ width: '45%' }} src={BTN2} alt="" onClick={() => setVisible(true)} />
      </div>
      <Mask opacity='thick' visible={visible} onMaskClick={() => setVisible(false)}>
        <img onClick={() => setVisible(false)} src={FXT} style={{ position: 'absolute', right: 0, top: 0, width: 200 }} />
      </Mask>
    </div>
  );
};

export default TestResult;
